import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckCircle1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "check-circle-1" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M6,13.223,8.45,16.7a1.049,1.049,0,0,0,1.707.051L18,6.828"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 12,
			cy: 11.999,
			r: 11.25
		})
	]
});
export default SvgCheckCircle1;
